(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-brand"] && !Shopify.designMode) return;
  try {
    
  // Brand carousel: native horizontal scrolling (swipe / trackpad), mouse drag and arrow buttons, plus a slow drift while
  // nobody is interacting. The list is rendered twice; the scroll position wraps by one list width so it never ends.
  if (!customElements.get('brand-marquee')) {
    customElements.define(
      'brand-marquee',
      class BrandMarquee extends HTMLElement {
        connectedCallback() {
          this.scroller = this.querySelector('.shop-by-brand__marquee');
          if (!this.scroller) return;
          this.pausedUntil = 0;
          this.hovering = false;
          this.visible = false;
          this.carry = 0;
          this.drift = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          requestAnimationFrame(() => (this.scroller.scrollLeft = this.half()));
          this.scroller.addEventListener('scroll', () => this.wrap(), { passive: true });
          for (const type of ['pointerdown', 'wheel', 'touchstart']) {
            this.scroller.addEventListener(type, () => this.pause(), { passive: true });
          }
          this.addEventListener('focusin', () => this.pause(8000));
          this.addEventListener('mouseenter', () => (this.hovering = true));
          this.addEventListener('mouseleave', () => (this.hovering = false));
          this.querySelectorAll('[data-direction]').forEach((button) =>
            button.addEventListener('click', () => this.step(Number(button.dataset.direction)))
          );
          this.enableDrag();

          new IntersectionObserver(([entry]) => (this.visible = entry.isIntersecting)).observe(this);
          if (this.drift) requestAnimationFrame((time) => this.tick(time));
        }

        half() {
          return this.scroller.scrollWidth / 2;
        }

        pause(ms = 4000) {
          this.pausedUntil = performance.now() + ms;
        }

        // Keep the position inside the duplicated range: content at x and x + half is identical
        wrap() {
          const half = this.half();
          const max = this.scroller.scrollWidth - this.scroller.clientWidth;
          if (this.scroller.scrollLeft < 1) this.scroller.scrollLeft += half;
          else if (this.scroller.scrollLeft > max - 1) this.scroller.scrollLeft -= half;
        }

        step(direction) {
          this.pause(6000);
          const distance = this.scroller.clientWidth * 0.75 * direction;
          // quick repeated clicks add up instead of restarting from wherever the smooth scroll has got to
          const busy = performance.now() - (this.stepTime ?? 0) < 500;
          let target = (busy ? this.stepTarget : this.scroller.scrollLeft) + distance;
          const max = this.scroller.scrollWidth - this.scroller.clientWidth;
          // jump by one list width first so the smooth scroll never runs into an edge
          const shift = target < 1 ? this.half() : target > max - 1 ? -this.half() : 0;
          if (shift) {
            this.scroller.scrollLeft += shift;
            target += shift;
          }
          this.stepTarget = target;
          this.stepTime = performance.now();
          this.scroller.scrollTo({ left: target, behavior: 'smooth' });
        }

        enableDrag() {
          let startX = 0;
          let startLeft = 0;
          let moved = false;
          this.scroller.addEventListener('pointerdown', (event) => {
            if (event.pointerType !== 'mouse' || event.button !== 0) return;
            startX = event.clientX;
            startLeft = this.scroller.scrollLeft;
            moved = false;
            const onMove = (move) => {
              const delta = move.clientX - startX;
              if (Math.abs(delta) > 5) {
                moved = true;
                this.scroller.classList.add('is-dragging');
              }
              if (moved) this.scroller.scrollLeft = startLeft - delta;
            };
            const onUp = () => {
              window.removeEventListener('pointermove', onMove);
              this.scroller.classList.remove('is-dragging');
              this.pause();
            };
            window.addEventListener('pointermove', onMove);
            window.addEventListener('pointerup', onUp, { once: true });
          });
          // the browser's own link/image dragging would cancel the pointer events
          this.scroller.addEventListener('dragstart', (event) => event.preventDefault());
          // a drag must not open the brand under the cursor
          this.scroller.addEventListener(
            'click',
            (event) => {
              if (moved) {
                event.preventDefault();
                moved = false;
              }
            },
            true
          );
        }

        tick(time) {
          const last = this.lastTime ?? time;
          this.lastTime = time;
          if (this.visible && !this.hovering && time > this.pausedUntil && !document.hidden) {
            this.carry += ((time - last) * 40) / 1000; // 40 px per second
            if (this.carry >= 1) {
              const whole = Math.floor(this.carry);
              this.carry -= whole;
              this.scroller.scrollLeft += whole;
            }
          }
          requestAnimationFrame((next) => this.tick(next));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
